var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chatroom-scoll",attrs:{"id":"message-area"}},_vm._l((_vm.message),function(item){return _c('message-item',{key:item.id,attrs:{"item":item,"id":"item.id"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }